import React from 'react';
import { Redirect, Link } from 'react-router-dom';
import Sidebar from '../../Components/Sidebar/Sidebar';
import ChamadoCreateFormAnalista from './ChamadoCreateFormAnalista';
import '../chamadoCreate.css';

function ChamadoCreatePageAnalista({
    numero,
    selected,
    onSolicitanteChange,
    data,
    descricao,
    setDescricao,
    tipo,
    setTipo,
    setor,
    setSetor,
    codSis,
    setCodSis,
    codEqp,
    setCodEqp,
    listSistemas,
    listaEquipamento,
    tipos,
    emailAdicional,
    setEmailAdicional,
    nomeAnexo,
    onAnexoChange,
    onSubmit,
    salvando,
    mensagem,
    sucesso,
}) {
    if (sucesso === 'S') {
        return <Redirect to="/home" />;
    }

    return (
        <div className="app-layout">
            <Sidebar />
            <main className="main-content">
                <div className="chamado-create-page">
                    <header className="chamado-create-header">
                        <Link to="/home" className="chamado-create-back">
                            <i className="fas fa-arrow-left" /> Voltar para chamados
                        </Link>
                        <h1>Novo Chamado</h1>
                        <p className="chamado-create-subtitle">Abertura de chamado pelo analista. Preencha solicitante, descrição e demais dados.</p>
                    </header>
                    <ChamadoCreateFormAnalista
                        numero={numero}
                        selected={selected}
                        onSolicitanteChange={onSolicitanteChange}
                        data={data}
                        descricao={descricao}
                        setDescricao={setDescricao}
                        tipo={tipo}
                        setTipo={setTipo}
                        setor={setor}
                        setSetor={setSetor}
                        codSis={codSis}
                        setCodSis={setCodSis}
                        codEqp={codEqp}
                        setCodEqp={setCodEqp}
                        listSistemas={listSistemas}
                        listaEquipamento={listaEquipamento}
                        tipos={tipos}
                        emailAdicional={emailAdicional}
                        setEmailAdicional={setEmailAdicional}
                        nomeAnexo={nomeAnexo}
                        onAnexoChange={onAnexoChange}
                        onSubmit={onSubmit}
                        salvando={salvando}
                        mensagem={mensagem}
                    />
                </div>
            </main>
        </div>
    );
}

export default ChamadoCreatePageAnalista;
